module.exports = __webpack_public_path__ + "img/Products_Desktop_04.786c46e4.jpg";